var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-alert',{attrs:{"show":"","variant":"red","align":"center"}},[_vm._v(_vm._s(_vm.$t('white-label.globalMessages.streamingError')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }